import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const whyChooseUs = [
    {
      icon: '/icons/star.svg',
      title: 'Premium Quality Finishes',
      description: 'We deliver exceptional quality with attention to detail in every project.'
    },
    {
      icon: '/icons/check.svg',
      title: 'Fast Turnaround Times',
      description: 'Efficient processes ensure quick delivery without compromising quality.'
    },
    {
      icon: '/icons/settings.svg',
      title: 'Eco-Friendly Processes',
      description: 'Environmentally conscious coating solutions for sustainable results.'
    },
    {
      icon: '/icons/star.svg',
      title: 'Competitive Pricing',
      description: 'Fair and transparent pricing with excellent value for money.'
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('message', formData.message);
      formDataToSend.append('_subject', 'New Enquiry from Glitter Metal Website');
      formDataToSend.append('_template', 'table');
      formDataToSend.append('_captcha', 'false');
      formDataToSend.append('_next', window.location.origin + '/#contact');

      const response = await fetch('https://formsubmit.co/glittermetalworks@gmail.com', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        // Show success message
        setShowSuccess(true);
        
        // Clear form
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });

        // Hide success message after 10 seconds
        setTimeout(() => {
          setShowSuccess(false);
        }, 10000);
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error submitting your message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2>Contact Us</h2>
          <p>Ready to start your powder coating project? Contact us today for a free consultation and quote for your specific requirements.</p>
        </div>

        <div className="why-choose-us">
          <h3>Why Choose Us?</h3>
          <div className="reasons">
            {whyChooseUs.map((reason, index) => (
              <div key={index} className="reason">
                <img src={reason.icon} alt={reason.title} className="reason-icon" />
                <div className="reason-content">
                  <h4>{reason.title}</h4>
                  <p>{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="cta-text">Let us transform your metal with durability and style. Contact us today for a free quote!</p>
        </div>
        
        <div className="contact-content">
          <div className="contact-form-container">
            <div className="contact-header">
              <h3>Get In Touch</h3>
              <p>Send us an enquiry and we'll get back to you within 24 hours.</p>
            </div>
            
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleInputChange}
                  required 
                  placeholder="Enter your full name"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleInputChange}
                  required 
                  placeholder="Enter your email address"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="Enter your phone number"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea 
                  id="message" 
                  name="message" 
                  value={formData.message}
                  onChange={handleInputChange}
                  required 
                  rows="5"
                  placeholder="Tell us about your project requirements..."
                ></textarea>
              </div>
              
              <div className="form-group">
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <div className="spinner"></div>
                      Sending...
                    </>
                  ) : (
                    <>
                      <img src="/icons/email.svg" alt="Send" className="submit-icon" />
                      Send Message
                    </>
                  )}
                </button>
              </div>
            </form>

            {showSuccess && (
              <div className="success-message">
                <img src="/icons/check.svg" alt="Success" className="success-icon" />
                <div>
                  <h4>Thank you for contacting us!</h4>
                  <p>Our team will get back to you within 24 hours.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 